import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {TeamMoshicomUserConnection} from '../model/resources/team';
import {ClientTeamMoshicomEvent} from '../model/resources/event';


@Injectable({
  providedIn: 'root'
})
export class MoshicomApiService {


  constructor(private apiService: ApiService) {
  }

  async getConnections(teamId: number, hideLoading?: boolean): Promise<TeamMoshicomUserConnection[] | null> {
    try {
      return await this.apiService.get<TeamMoshicomUserConnection[]>(teamId, `moshicom/connections`, hideLoading);
    } catch (e) {
      return null;
    }
  }

  async postConnection(teamId: number, loginId: string, password: string, hideLoading?: boolean): Promise<TeamMoshicomUserConnection | null> {
    try {
      return await this.apiService.post<TeamMoshicomUserConnection>(teamId, `moshicom/connections`, {loginId, password}, hideLoading);
    } catch (e) {
      return null;
    }
  }

  async deleteConnection(teamId: number, runnetId: number, hideLoading?: boolean): Promise<boolean> {
    try {
      await this.apiService.delete(teamId, `moshicom/connections?runnetId=${runnetId}`, hideLoading);
      return true;
    } catch (e) {
      return false;
    }
  }

  /**
   * モシコムから取り込んだTeamEventを取得する
   * @param teamId
   * @param hideLoading
   */
  async getTeamMoshicomEvents(teamId: number, hideLoading?: boolean): Promise<ClientTeamMoshicomEvent[]> {
    try {
      return await this.apiService.get(teamId, `moshicom/events`, hideLoading);
    } catch (e) {
      return [];
    }
  }

  /**
   * モシコムからイベント情報を取得しTeamEventへ変換し保存する
   * @param teamId
   * @param hideLoading
   */
  async updateTeamMoshicomEvents(teamId: number, hideLoading?: boolean): Promise<boolean> {
    try {
      return await this.apiService.post(teamId, `moshicom/events`, hideLoading);
    } catch (e) {
      return false;
    }
  }

  /**
   * チーム内イベントとして公開/非公開を切り替える
   * @param teamId
   * @param uuid
   * @param visible
   * @param hideLoading
   */
  async patchTeamMoshicomEvent(teamId: number, uuid: string, visible: boolean, hideLoading?: boolean): Promise<boolean> {
    try {
      await this.apiService.patch(teamId, `moshicom/events/${uuid}`, {visible}, hideLoading);
      return true
    } catch (e) {
      return false;
    }
  }
}
